<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="localValue"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="localValue ? localValue.substr(0, 10) : null"
        :label="label"
        :error-messages="errorMessages"
        prepend-icon="mdi-calendar"
        readonly
        outlined
        :clearable="true"
        v-bind="attrs"
        @click:clear="localValue = null"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="localValue"
      no-title
      color="primary"
      scrollable
      v-bind="$attrs"
    >
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="menu = false"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="$refs.menu.save(localValue)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: 'Date'
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      menu: false,
      localValue: this.value
    }
  },

  watch: {
    localValue: function(val) {
      this.$emit('input', val)
    },

    value: function(val) {
      this.localValue = val
    }
  }
}
</script>